import { notification } from "antd";
import axios, { AxiosError } from "axios";
import { pauseLoader, startLoader } from "../redux/actions";
import store from "../redux/store";
import { getAccessToken } from "../Services/AuthenticationServices/AuthenticationServices";
import {
  getLocalStorageItem,
  localStorageConstants,
  setAccessToken,
  setPhoneNumber,
  setRefreshToken,
  setVuaId,
} from "../Services/LocalStorageServices";
import { baseUrl } from "./Constants/baseUrl";
import { QueryParams, Routes } from "./Constants/routes";
import { apiTimeout } from "./Constants/ServerTimeout";
const interceptor = (history: any) => {
  axios.defaults.baseURL = baseUrl;
  axios.interceptors.request.use(
    (request) => {
      store.dispatch(startLoader());
      if (request.data === undefined) {
        request.data = {};
      }
      request.headers = {
        ...request.headers,
        "Content-Type": "application/json",
      };
      if (
        getLocalStorageItem(localStorageConstants.accessToken) &&
        !request.url?.includes("public") &&
        !request.url?.includes("/User/forgetPassword")
      ) {
        request.headers = {
          ...request.headers,
          Authorization: `Bearer ${getLocalStorageItem(
            localStorageConstants.accessToken
          )}`,
        };
      }
      request.timeout = apiTimeout;
      return request;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    }
  );
  // Add a response interceptor
  axios.interceptors.response.use(
    // tslint:disable-next-line: only-arrow-functions
    function (response) {
      store.dispatch(pauseLoader());
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    // tslint:disable-next-line: only-arrow-functions
    async function (error: AxiosError) {
      store.dispatch(pauseLoader());

      if (error.response?.status === 302) {
        return Promise.reject(error);
      }

      const originalRequest = error ? error.config : undefined;
      if (
        originalRequest === undefined ||
        originalRequest.url === "/public/user/refreshtoken"
      ) {
        return Promise.reject(error);
      }
      if (error.response?.status === 401) {
        if (
          originalRequest.url !== "/public/user/verify-otp" &&
          originalRequest.url !== "/public/user/login" &&
          originalRequest.url !== "/public/user/send-otp" &&
          originalRequest.url !== "/public/user/signup/verify"
        ) {
          const res = await getAccessToken(
            getLocalStorageItem(localStorageConstants.refreshToken)
          ).catch((res1) => {
            return res1;
          });
          if (res.status === 200) {
            setAccessToken(res.data.access_token);
            setRefreshToken(res.data.refresh_token);
            return axios(originalRequest);
          } else {
            setAccessToken("");
            setPhoneNumber("");
            setRefreshToken("");
            setVuaId("");
            notification.error({
              message: "Session Timeout",
              description: "",
              duration: 3,
            });
            history.push({
              pathname: Routes.login,
              search:
                history.location.pathname !== Routes.login
                  ? `?${QueryParams.redirect}=${history.location.pathname}`
                  : undefined,
            });
            return Promise.reject(res.data);
          }
        } else {
          notification.error({
            message: error.response?.data.errorCode
              ? error.response?.data.errorCode
              : "user not authorized",
            description: "",
            duration: 3,
          });
        }
      } else if (error.code === "ECONNABORTED") {
        notification.error({
          message: "Server Timeout",
          duration: 3,
        });
      } else {
        notification.error({
          message: error.response?.data.errorCode
            ? error.response?.data.errorCode
            : "Something went wrong",
          description: error.response?.data.errorMsg
            ? error.response?.data.errorMsg
            : "",
          duration: 3,
        });
        if (error.response?.data.redirectUrl) {
          window.location.replace(error.response?.data.redirectUrl);
        }
      }
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    }
  );
};
export default interceptor;
